/* eslint eol-last: ["error", "never"] */
export default {
    loading: false,
    contactoslist: true,
    contactosadd: false,
    contactos: [],
    documentos: [],
}